import { Zero as rocicorp_Zero } from "@rocicorp/zero"
import { createUseZero } from "@rocicorp/zero/react"
import type { AuthData } from "../../shared/auth.ts"
import { createMutators, type mutators } from "../../shared/mutators.ts"
import { schema } from "../../shared/schema.ts"

export const useZero = createUseZero<schema, mutators>()

export function create(authData: AuthData | null | undefined) {
  return new rocicorp_Zero(options(authData))
}

export function options(authData: AuthData | null | undefined) {
  return {
    logLevel: "warn",
    mutators: createMutators(authData),
    schema,
    server: (() => {
      if (
        import.meta.env.DEV &&
        globalThis.location?.hostname.includes("tunnel")
      )
        return import.meta.env.VITE_TUNNEL_SYNC_URL
      return import.meta.env.VITE_SYNC_URL
    })(),
    userID: authData?.id ?? "anon",
  } satisfies ConstructorParameters<typeof rocicorp_Zero>[0]
}

export type Zero = rocicorp_Zero<schema, mutators>
